import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: false
})
export class ToastComponent {
  @Input() message = { body: '', type: '' };
  existingTimeout: any;

  setMessage(body: string, type: string, time = 5000): void {
    if (this.existingTimeout) {
      clearTimeout(this.existingTimeout);
    }
    time = type === 'danger' ? 7500 : time;
    this.message.body = body;
    this.message.type = type;
    this.existingTimeout = setTimeout(() => this.message.body = '', time);
  }

}
